module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point1_1-5355488d90c5c86623d5d852c443f670.jpg";